import { useEffect } from 'react';

// Injects a JSON-LD <script> for the mounted route and removes it on unmount.
//
// WHY THIS EXISTS
// 87% of new users arrive from organic search and the app shipped ZERO
// structured data — no FAQPage despite a 12-item FAQ built expanded-in-the-DOM
// specifically for crawlers, no Organization, nothing. This is the cheapest
// available SEO surface on the highest-leverage channel in the business.
//
// Rendered as an effect rather than as JSX because React escapes text content
// inside <script> tags, which corrupts the JSON.
//
// SAFETY: the payload is serialised with JSON.stringify and `</` is escaped, so
// copy containing a literal "</script>" cannot break out of the tag. Everything
// passed here comes from our own copyMap, but this is a script tag — it gets
// the treatment regardless.
export default function StructuredData({ id, data }) {
  useEffect(() => {
    if (!data) return undefined;

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.textContent = JSON.stringify(data).replace(/</g, '\\u003c');
    document.head.appendChild(script);

    return () => {
      // Guard the removal: a hot reload or a double-mount can leave the node
      // already detached, and throwing in a cleanup breaks the unmount.
      if (script.parentNode) script.parentNode.removeChild(script);
    };
  }, [id, data]);

  return null;
}
